import moment from "moment";
import Calendar from "rc-calendar";
import "rc-calendar/assets/index.css";
import { lazy, useEffect, useLayoutEffect, useRef, useState } from "react";
import { BiCalendar } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import { HiPencil } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { GetTodaysDateINdmy } from "../../../CommonFunction/GetTodaysDate";
import { onDependEmptyField } from "../../../CommonFunction/OnDependEmptyField";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { InputCheckbox } from "../InputCheckbox/InputCheckbox";
import InputDropdown from "../InputDropdown/InputDropdown";
import InputDropdownForQuery from "../InputDropdown/InputDropdownForQuery";
import InputToHandleGoogleAPI from "../InputDropdown/InputToHandleGoogleAPI";
import CustoutMask from "../InputMask/InputMask";
import { useModalContext } from "../Reactportal/ModalContext";
import { WarningToast } from "../ToastComponent/RectHotToast";
import OutsideClick from "../onOutSideClick/OutSideClick";
import ApiButtonInput from "./ApiButtonInput";
import { enterKeyHandle } from "./DateInputFunction/DateInputFunction";
import "./Input.scss";
import InputMultiSelect from "./InputMultiSelect/InputMultiSelect";
import {
  CheckDisable,
  OpenMasterModal,
  capitalizeFirstCharacter,
  getClassName,
  handleKeyDown,
} from "./InputRelatedFunctions";
import CustomTimePicker from "./InputTimePicker/InputTimePicker";

const loadIcon = (library, iconName, abc = "react-icons") => {
  return lazy(() =>
    import(`${abc}/${library}/index.js`).then((module) => ({
      default: module[iconName] || module["IoWarning"], // Fallback icon if not found
    }))
  );
};
const Input = ({
  InputConfig,
  TypeOfPortal,
  name,
  EMTQuery,
  handleInputChange,
  type,
  modalform,
  Section_Type,
  value,
  className,
  touched,
  error,
  dropdowndata = [],
  handleBlur = (e) => {},
  label,
  max,
  JurnalDropdown,
  disabled,
  checked,
  onFocus = (e) => {},
  transactions,
  PaymentProcess,
  notSearchable,
  Touch_inp = "",
  RowId = "",
  formkey = "",
  fielddata = {},
  setAllFieldsData = () => {},
  id = "",
}) => {
  const MasterData = useSelector((store) => store?.FormDataReducer?.MasterData?.[formkey]);
  // console.log(name, type)
  const FormData = useSelector((store) => store?.FormDataReducer?.[formkey]);
  const { selectedFinancialYears, SelectedDate } = useSelector((store) => store?.financialYear);
  let dates = selectedFinancialYears && selectedFinancialYears?.split(" - ");
  let ReferedFieldDate = MasterData?.ReferFieldForDate;
  const dispatch = useDispatch();
  const { pushModal } = useModalContext();
  const [open, setOpen] = useState(false);
  const [openDate, setOpenDate] = useState(false);
  const [selectData, setSelectData] = useState(dropdowndata);
  const [searchText, setSearchText] = useState(value);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [CompName, setcompName] = useState();
  const [props, setProps] = useState({});
  const [detectBlur, setBlur] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const inputRef = useRef();
  // a ref to hold the last cursor position
  const lastCursorRef = useRef(null);

  const focusMoment = moment(dates[0], "DD/MM/YYYY");

  // Create a synthetic event to update the input programmatically
  const updateInputValue = (newValue) => {
    const event = {
      target: {
        name: name, // Ensure this uses the correct "name" of the input
        value: newValue,
      },
    };
    inputcontent(event);
  };

  const inputcontent = (event) => {
    if (typeof event === "string" || Array.isArray(event)) {
      // If a string is passed, create and handle a synthetic event
      updateInputValue(event);
    } else if (type === "Number") {
      handleInputChange(event);
    } else {
      handleInputChange(event);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      setDimensions({
        width: inputRef.current.offsetWidth,
        height: inputRef.current.offsetHeight,
      });
    }
  }, []);

  useEffect(() => {
    if (InputConfig?.Reference_field) {
      let typeName = InputConfig?.Reference_field;
      // setRefField(typeName);
      if (typeName[1] !== "") {
        let Reference = MasterData?.[typeName[0]]?._id;
        let current = MasterData?.[name]?.[typeName[1]];
        console.log(Reference, current, MasterData, name, typeName, "currentcurrentcurrent");
        if (Reference !== current) {
          inputcontent("");
          onDependEmptyField(InputConfig.name, formkey, dispatch, setAllFieldsData, fielddata?.[typeName[0]]);
        }
      }
    }
  }, [MasterData?.[InputConfig?.Reference_field?.[0]]?._id]);

  useEffect(() => {
    if (dropdowndata?.length) {
      setSelectData(dropdowndata);
    }
  }, [dropdowndata]);

  const handleSelectSearch = (searchValue) => {
    setOpen(true);
    if (MasterData && MasterData[name]) {
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey,
          data: { [name]: "" },
        },
      });
    }
    setSearchText(searchValue);
  };
    useLayoutEffect(() => {
    const pos = lastCursorRef.current;
    if (pos != null && inputRef.current) {
      inputRef.current.setSelectionRange(pos, pos);
      lastCursorRef.current = null;
    }
  }, [value]);
  
  const handleDropDownClose = (action) => {
    setOpen(false);
  };

  function PushModal(val) {
    pushModal(val);
  }

  function convertToUppercase(e) {
    e.target.value = e.target.value.toUpperCase();
  }
  const handleBlurForDropdown = () => {
    setBlur((prev) => {
      return !prev;
    });
  };
  let propOBJ = { label, name, value, handleInputChange };
  let DropDownProps = {
    inputcontent,
    searchText,
    detectBlur,
    setBlur,
    setSearchText,
    open,
  };



  if (type === "time") {
    return (
      <OutsideClick setToggled={setOpen}>
        <CustomTimePicker {...propOBJ} isRequired={InputConfig.isRequired} />
      </OutsideClick>
    );
  }
  if (type === "Check-Box") {
    return (
      <InputCheckbox
        disabled={disabled}
        label={label}
        name={name}
        value={value}
        handleInputChange={handleInputChange}
      />
    );
  }
  if (type === "inputMask") {
    return (
      <>
        <CustoutMask
          className={className}
          label={label}
          name={name}
          value={value}
          handleInputMaskChange={handleInputChange}
          inputBoxNumber={InputConfig?.inputBoxNumber}
          inputDigitLimit={InputConfig?.inputDigitLimit}
          touched={touched}
          error={error}
          modalform={modalform}
        />
      </>
    );
  }
  if (type === "apiButtonInput") {
    return (
      <ApiButtonInput
        InputConfig={InputConfig}
        inputRef={inputRef}
        placeholder={replaceUnderscore(name)}
        className={getClassName(type, className, "")}
        name={name}
        value={value}
        onChange={(e) => inputcontent(e)}
        label={label}
        height={dimensions.height}
        RowId={RowId}
        dispatch={dispatch}
        formkey={formkey}
        onBlur={(e) => {}}
        onFocus={(e) => {}}
      />
    );
  }
  if (type === "Text Box(Multi Line)") {
    return (
      <>
        <div className={modalform ? "form__group field" : ""}>
          <textarea
            ref={inputRef}
            value={value || ""}
            className={
              modalform
                ? `form__field ${className} ${touched && error ? "error_input" : ""} textArea`
                : `${className} textArea`
            }
            name={name}
            id={id || name}
            onChange={(e) => {
              InputConfig?.FirstCharCap && capitalizeFirstCharacter(e);
              inputcontent(e);
            }}
            onBlur={(e) => {
              handleBlur(e);
            }}
            onFocus={(e) => {}}
            wrap="soft"
            style={{ whiteSpace: "pre-wrap", resize: "vertical" }}
          ></textarea>
          <label className={"form__label textAreaLabel "}>
            {label ? label : name} {InputConfig.isRequired && <span className="required_label"> *</span>}
          </label>
        </div>
      </>
    );
  }
  if (type === "radio-type") {
    return (
      <div className={`radioGrop ${className || ""}`}>
        <div>
          <label className={`form__label_radio`}>
            {label && replaceUnderscore(name)}
            {InputConfig?.isRequired && <span className="required_label"> *</span>}
          </label>
        </div>
        <label className="radioLabel">
          <input
            type="radio"
            name={name}
            checked={value === true || value === "true"}
            disabled={disabled}
            onChange={() => handleInputChange({ target: { name, value: true } })}
          />
          Yes
        </label>
        <label className="radioLabel" style={{ marginLeft: "1rem" }}>
          <input
            type="radio"
            name={name}
            checked={value === false || value === "false"}
            disabled={disabled}
            onChange={() => handleInputChange({ target: { name, value: false } })}
          />
          No
        </label>
      </div>
    );
  }

  return (
    <>
      <div className={modalform ? `form__group field` : ""}>
        <input
          ref={inputRef}
          checked={checked}
          id={id || name}
          autoComplete="off"
          autoFocus={InputConfig?.autoFocus && !TypeOfPortal?.includes("View")}
          disabled={disabled ? true : false}
          placeholder={modalform ? "" : replaceUnderscore(name)} // replaceUnderscore(props.name)}
          className={
            ["InputDropForQuery", "Dropdown", "GoogleSearch"].includes(type)
              ? `${Touch_inp} form__field ${className || ""} no-spinners dropdownInput`
              : type === "radio"
              ? `${className || ""}`
              : `${className || ""} form__field no-spinners`
          }
          type={type === "Date" || type === "GoogleSearch" || type === "Text Box(Single Line)" ? "text" : type}
          name={name}
          value={
            type === "Multi-Select" && value?.length
              ? `${value.length} Selected`
              : type === "Multi-Select"
              ? ""
              : value ?? ""
          }
          min={type === "Number" ? 0 : {}}
          onKeyDown={(e) => {
            if (type === "Date") {
              enterKeyHandle(e, inputcontent, InputConfig, SelectedDate, name, ReferedFieldDate, value, formkey);
              setOpen(false);
            } else if (type === "Number") {
              handleKeyDown(e, type);
            } else if (type === "InputDropForQuery") {
              OpenMasterModal(
                InputConfig,
                e,
                setIsModalOpen,
                setcompName,
                isModalOpen,
                setProps,
                dispatch,
                InputConfig.rowId ? MasterData?.[InputConfig.rowId]?.[name] : MasterData?.[name],
                formkey,
                PushModal,
                id
              );
            }
          }}
          onChange={(e) => {
            InputConfig?.FirstCharCap && capitalizeFirstCharacter(e);

            lastCursorRef.current = e.target.selectionStart;

            if (InputConfig?.spaceNotAllowed) {
              //This functionality for space not allowed in the text
              const newValue = e.target.value.replace(/\s+/g, "");
              e.target.value = newValue;
            }
            if (e.target.value.length > max) {
              return;
            } else if (type === "Number") {
              const value = e.target.value;
              const isValid = !isNaN(parseFloat(value));
              if (!isValid) {
                e.target.value = ""; // or handle invalid input as needed
              }
            } else if (type === "Dropdown" || type === "InputDropForQuery" || type === "GoogleSearch") {
              handleSelectSearch(e.target.value);
            } else if (InputConfig?.AllCaps) {
              convertToUppercase(e);
            }

            inputcontent(e);
          }}
          onPaste={(e) => {
            if (InputConfig?.restrictDateRange) {
              if (type === "Date") {
                e.preventDefault();
                WarningToast("Please Manually Enter the date.");
              }
            }
          }}
          onFocus={(e) => {
            setOpen(true);
            typeof onFocus === "function" && onFocus(e);
          }}
          onBlur={(e) => {
            const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(20[0-9]{2})$/;
            const { value } = e.target;
            handleBlur(e);
            error = {};
            handleBlurForDropdown();
            if (type !== "Date") {
              setTimeout(() => {
                type !== "Multi-Select" && setOpen(false);
              }, 300);
            } else {
              if (!dateRegex.test(value)) {
                inputcontent("");
              }
            }
          }}
          style={type === "Number" ? { textAlign: "right" } : null} // conditional inline style
        />

        {(dropdowndata?.length || type === "InputDropForQuery" || type === "GoogleSearch") && open ? (
          <OutsideClick setToggled={setOpen}>
            <div className={type !== "InputDropForQuery" ? "inputdropdown" : "inputdropdownforQuery"} tabIndex={-1}>
              {type === "InputDropForQuery" ? (
                <InputDropdownForQuery
                  {...DropDownProps}
                  Section_Type={Section_Type}
                  handleDropDownClose={() => handleDropDownClose()}
                  name={name}
                  EMTQuery={EMTQuery}
                  InputConfig={InputConfig}
                  formkey={formkey}
                  width={dimensions.width}
                  AddNew={(keyCode) => {
                    // console.log(keyCode, "keyCodekeyCode");
                    OpenMasterModal(
                      InputConfig,
                      { keyCode },
                      setIsModalOpen,
                      setcompName,
                      isModalOpen,
                      setProps,
                      dispatch,
                      MasterData?.[name],
                      formkey,
                      PushModal,
                      id
                    );
                  }}
                  RowId={RowId}
                  id={id}
                />
              ) : type === "Multi-Select" ? (
                <InputMultiSelect dropdowndata={selectData} inputcontent={inputcontent} SelectedItems={value} />
              ) : type === "GoogleSearch" ? (
                <InputToHandleGoogleAPI {...DropDownProps} name={name} formkey={formkey} />
              ) : (
                <InputDropdown
                  {...DropDownProps}
                  dropdowndata={selectData}
                  handleDropDownClose={handleDropDownClose}
                  notSearchable={notSearchable}
                  InputConfig={InputConfig}
                  value={value}
                />
              )}
            </div>
          </OutsideClick>
        ) : (
          ""
        )}

        {modalform && !JurnalDropdown ? (
          <label className={`form__label`}>
            {label && label !== "No Label"
              ? replaceUnderscore(label)
              : label === "No Label"
              ? null
              : replaceUnderscore(name)}
            {InputConfig?.isRequired && <span className="required_label"> *</span>}
          </label>
        ) : (
          ""
        )}
        {InputConfig?.icon && (
          <div className="InputEditIcon" typeof="button">
            <HiPencil className="icondown " />
          </div>
        )}
        {modalform && (dropdowndata?.length || type === "InputDropForQuery") ? (
          <BsChevronDown
            type="button"
            disabled={inputRef?.current?.disabled} // this checks both local state and input's disabled state
            className={PaymentProcess ? "paymentTypeIcon" : "icondown"}
            onClick={() => {
              if (!inputRef?.current?.disabled) {
                setOpen(true);
              }
            }}
          />
        ) : (
          ""
        )}
        {type === "Date" ? (
          <BiCalendar
            onClick={() => {
              setOpenDate(!openDate);
              inputRef.current.focus();
            }}
            className="calandericon"
          ></BiCalendar>
        ) : (
          ""
        )}
        {openDate && type === "Date" ? (
          <OutsideClick setToggled={setOpenDate}>
            <div className="calanderdropdown">
              <Calendar
                className="hide-input"
                defaultValue={
                  InputConfig?.restrictDateRange && InputConfig?.Reference_field === "financialYear"
                    ? focusMoment
                    : GetTodaysDateINdmy()
                }
                onSelect={(date) => {
                  const formattedDate = date.format("DD/MM/YYYY");
                  inputcontent(formattedDate);
                  setOpenDate(false);
                }}
                disabledDate={(current) => {
                  return CheckDisable(current, InputConfig, SelectedDate, dates, Section_Type, FormData);
                }}
              />
            </div>
          </OutsideClick>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default Input;
